import { useTranslator } from "@eo-locale/react";

import NextHead from "next/head";

import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { wrapper } from "@/redux/store/store";
import { withCommonData } from "@/hocs/with-common-data";
import { withParticipantData } from "@/hocs/with-participant-data";
import type { ReactElement } from "react";
import { withAuthCookie } from "@/hocs/with-auth-cookie";
import { withUserSession } from "@/hocs/with-user-session";
import { withProjectAccess } from "@/hocs/with-project-access";
import Banner from "@/components/tools/brainstormer/banner";
import { fetchBrainstormers } from "@/redux/features/brainstormers/thunk";
import { fetchBackgroundColours } from "@/redux/features/tool-customizations/thunk";
import EmbedsLayout from "@/components/shared/layouts/embeds/default";
import { useAppSelector } from "@/redux/store/hooks";

import { fetchProject } from "@/redux/features/project/thunk";

export default function Page() {
  const { translate } = useTranslator();
  const { site } = useAppSelector((state) => state.site);

  return (
    <>
      <NextHead>
        <title>{`${translate("brainstormers.idea")} | ${site.name}`}</title>
      </NextHead>
      <Banner />
    </>
  );
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <EmbedsLayout>{page}</EmbedsLayout>;
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  withParticipantData(
    withUserSession(
      withProjectAccess(
        withAuthCookie(
          wrapper.getServerSideProps(
            (store) => async (ctx: GetServerSidePropsContext) => {
              const config = {
                headers: {
                  cookie: ctx?.req?.headers?.cookie
                }
              };
              await store.dispatch(
                fetchProject({
                  projectId: ctx.query.projectId as string,
                  config
                })
              );
              await store.dispatch(
                fetchBrainstormers({ ...ctx.query, config })
              );
              await store.dispatch(fetchBackgroundColours({ config }));

              return {
                props: {}
              };
            }
          )
        )
      )
    )
  )
);
